import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type MetaOrder as SchemaMetaOrder } from '../schemas/MetaOrder';
import { type Order as SchemaOrder } from '../schemas/Order';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const UpdateOrderContentType = 'application/json' as const;
export type UpdateOrderRequest = SchemaMetaOrder;
export type UpdateOrderResponses = LinkCommonErrorResponses & {
    /**
     * @description Updated order
     */
    '200': {
        'application/json': SchemaOrder;
    };
};
export type UpdateOrderResponseSuccess = UpdateOrderResponses['200']['application/json'];
export type UpdateOrderSearchParams = {
    signature: string;
};
export type UpdateOrderPathParameters = {
    store_slug: string;
    order_id: string;
};
export const UpdateOrderUrl = '/{store_slug}/orders/{order_id}' as const;
export const UpdateOrderMethod = 'PATCH' as const;
export const getUpdateOrderUrl = (params: UpdateOrderPathParameters) =>
    UpdateOrderUrl.replace(/\{(\w+)\}/g, (_match, param: keyof UpdateOrderPathParameters) => String(params[param]));
